// The backend puts a generic summary in data.message, but the specific,
// actionable detail (e.g. "invoice already exists for PO X") often only
// shows up nested inside data.data, whose shape varies (a string, an array,
// or an object keyed by line-item/invoice id). Pull out every string value
// wherever it's nested, rather than assuming one fixed shape.
export const extractErrorDetail = (value, depth = 0) => {
  if (value == null || depth > 3) return []
  if (typeof value === "string") return [value]
  if (typeof value === "number" || typeof value === "boolean") return [String(value)]
  if (Array.isArray(value)) {
    return value.flatMap(item => extractErrorDetail(item, depth + 1))
  }
  if (typeof value === "object") {
    return Object.values(value).flatMap(item => extractErrorDetail(item, depth + 1))
  }
  return []
}

export const getErrorMessage = (error, fallbackMessage = "An unexpected error occurred.") => {
  const responseData = error.response?.data
  const detail = extractErrorDetail(responseData?.data).join("; ")
  const summary = responseData?.message

  if (detail && summary) return `${summary}: ${detail}`
  if (detail) return detail
  if (summary) return summary
  return error.message || fallbackMessage
}
